const model = {
    submitting: false,
    errors: null,
    genderDetails: null,
    success: false,
};

export default model;
